import { useRef } from 'react';
import Link from 'next/link';
import Menu, { MenuItem } from '@/components/Menu';
import ProfilePicture from '@/components/ProfilePicture';
import { AdminIcon, InvestorIcon, LogOutIcon, SettingsIcon } from '@/icons';
import {
  useCurrentInvestor,
  useCurrentProfile,
  useCurrentUser,
} from '@/hooks/useStore';
import { useToggle } from '@/hooks/useToggle';
import { renderProfileName } from '@/utils/strings';
import { goToLogin } from '@/utils/dom';
import { isAdmin } from '@/utils/users';
import { PAGES } from '@/constants/pages';
import { getInvestorUrl } from '@/api/getUrl';
import { classes, logout } from './utils';

export default function UserMenu() {
  const menuToggleRef = useRef<HTMLDivElement>(null);
  const currentUser = useCurrentUser();
  const profile = useCurrentProfile();
  const investor = useCurrentInvestor();
  const [isMenuOpen, toggleMenu] = useToggle(false);

  const handleLogOut = async () => {
    await logout();
    goToLogin();
  };

  if (!profile) return null;

  return (
    <div>
      <div
        ref={menuToggleRef}
        className={classes.wrapper}
        onClick={() => toggleMenu()}>
        <ProfilePicture size={32} profile={profile} />
        <div className={classes.label}>{renderProfileName(profile)}</div>
      </div>
      <Menu
        open={isMenuOpen}
        anchorTo={menuToggleRef.current}
        onClose={() => toggleMenu()}>
        <Link onClick={() => toggleMenu()} href={PAGES.PROFILE}>
          <MenuItem label="Account settings" icon={<SettingsIcon />} />
        </Link>
        {investor && (
          <Link onClick={() => toggleMenu()} href={getInvestorUrl(investor.id)}>
            <MenuItem label="Investor profile" icon={<InvestorIcon />} />
          </Link>
        )}
        {isAdmin(currentUser) && (
          <Link onClick={() => toggleMenu()} href={PAGES.ADMIN}>
            <MenuItem label="Admin" icon={<AdminIcon />} />
          </Link>
        )}
        <MenuItem
          label="Log Out"
          icon={<LogOutIcon />}
          onClick={handleLogOut}
        />
      </Menu>
    </div>
  );
}
